// 仅菜单/Tab 为静态配置；应用、作者、统计及列表均由后端返回。经验集市已拆分至 /experience-square 独立页面。
export const applicationTabs = [
  { id: 'all', title: '应用广场' },
  { id: 'mine', title: '我的发布' },
]
export const resourceTypes = ['Skill', '提效工具', 'AI系统', '智能应用']
export const publishCategories = ['品牌营销（运营）', '研发', '人力行政', '财务', 'AI数智技术', '品牌策划', '面辅料', '仓储', '智能制造', '供应链']
export const applicationCategories = ['全部', ...resourceTypes, ...publishCategories]
export const applicationStatuses = [
  { id: 'all', title: '全部' },
  { id: 'published', title: '已上架' },
  { id: 'pending', title: '待审批' },
  { id: 'rejected', title: '已驳回' },
  { id: 'offline', title: '已下架' },
  { id: 'draft', title: '草稿' }
]
export const applicationStatusLabel = app => applicationStatuses.find(item => item.id === app?.status)?.title || ''
export const cardPermissionLabel = app => ({ public: '公开', department: '部门', private: '个人' }[app?.permissionScope] || (app?.publicVisible ? '公开' : '个人'))

export function safeHttpUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return ''
  const raw = value.trim()
  // URL 构造函数会把 www.example.com 当成当前站点的相对路径，
  // 因此无协议地址统一按 HTTPS 处理，避免跳转到 localhost/www.example.com。
  if (/^[a-z][a-z\d+.-]*:/i.test(raw) && !/^https?:\/\//i.test(raw)) return ''
  const normalized = /^https?:\/\//i.test(raw) ? raw : `https://${raw.replace(/^\/\//, '')}`
  try {
    const url = new URL(normalized)
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? url.href : ''
  } catch { return '' }
}
